import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import { Observable, merge } from 'rxjs';
import Pusher from 'pusher-js';

class PusherService {
    config;
    accessToken;
    _pusher;
    observables = {};
    constructor(config) {
        this.config = config;
    }
    get pusher() {
        if (!this._pusher) {
            const config = {
                cluster: this.config.cluster ?? 'mt1',
                channelAuthorization: {
                    endpoint: this.config.authEndpoint,
                    transport: 'ajax',
                    headersProvider: () => {
                        if (!this.accessToken)
                            return {};
                        return {
                            Authorization: `Bearer ${this.accessToken}`,
                        };
                    },
                },
            };
            this._pusher = new Pusher(this.config.key, config);
        }
        return this._pusher;
    }
    destroyPusher() {
        if (this._pusher) {
            this.unsubscribeFromAll();
            this.pusher.disconnect();
            this._pusher = null;
        }
    }
    setAccessToken(accessToken) {
        if (!accessToken || !accessToken.length) {
            throw new Error(`Invalid access token: ${accessToken}`);
        }
        if (this.accessToken === accessToken)
            return;
        const didNotHaveToken = !this.accessToken;
        if (this._pusher && didNotHaveToken) {
            this.destroyPusher();
        }
        this.accessToken = accessToken;
    }
    clearAccessToken() {
        if (!this.accessToken)
            return;
        this.accessToken = null;
        this.destroyPusher();
    }
    subscribe(channelName, eventName) {
        const key = channelName + '_' + eventName;
        if (!this.observables[key]) {
            this.observables[key] = Observable.create(observer => {
                const channel = this.pusher.channel(channelName) ||
                    this.pusher.subscribe(channelName);
                channel.bind(eventName, data => observer.next({ name: eventName, data }));
            });
        }
        return this.observables[key];
    }
    subscribeToPresenceEvents(channelName) {
        return merge(this.subscribe(channelName, 'pusher:subscription_succeeded'), this.subscribe(channelName, 'pusher:subscription_error'), this.subscribe(channelName, 'pusher:member_added'), this.subscribe(channelName, 'pusher:member_removed'));
    }
    unsubscribe(channelName) {
        this.pusher.unsubscribe(channelName);
        Object.keys(this.observables).forEach(key => {
            if (key.startsWith(channelName + '_')) {
                // this.observables[key].dispose();
                delete this.observables[key];
            }
        });
    }
    unsubscribeFromAll() {
        Object.keys(this.observables).forEach(key => {
            const channelName = key.split('_')[0];
            this.pusher.unsubscribe(channelName);
        });
        this.observables = {};
    }
    trigger(channelName, eventName, data) {
        const channel = this.pusher.channel(channelName) || this.pusher.subscribe(channelName);
        channel.trigger(eventName, data);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: PusherService, deps: "invalid", target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: PusherService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: PusherService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined }] });

class PusherModule {
    static forRoot(config) {
        return {
            ngModule: PusherModule,
            providers: [
                {
                    provide: PusherService,
                    useFactory() {
                        return new PusherService(config);
                    },
                },
            ],
        };
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: PusherModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.1.4", ngImport: i0, type: PusherModule });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: PusherModule });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: PusherModule, decorators: [{
            type: NgModule
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { PusherModule, PusherService };
